import { makeAutoObservable } from 'mobx'

import type { TutorialOverlayVariant } from '../game/ui/TutorialOverlays'
import { playMusicInterruption } from '../utils/soundPlayer'

const ALL_OVERLAY_VARIANTS = ['shield', 'snap', 'plane'] as const satisfies readonly TutorialOverlayVariant[]

export class PowerUpTutorialStore {
    activeVariant: TutorialOverlayVariant | null = null

    // Star music deferred until the plane tutorial overlay is dismissed.
    private pendingStarMusic = false

    private shown: Set<TutorialOverlayVariant> = new Set()

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true })
    }

    get isOverlayVisible() {
        return this.activeVariant !== null
    }

    // True once every power-up tutorial popup has been shown at least once.
    get hasSeenAllOverlays() {
        return ALL_OVERLAY_VARIANTS.every((variant) => this.shown.has(variant))
    }

    // Whether requesting this overlay would currently show it.
    willShow(variant: TutorialOverlayVariant) {
        return this.activeVariant === null && !this.shown.has(variant)
    }

    requestOverlay(variant: TutorialOverlayVariant) {
        if (this.activeVariant !== null) return
        if (this.shown.has(variant)) return

        this.shown.add(variant)
        this.activeVariant = variant
    }

    // Hold musicStarCollect until the plane tutorial overlay is closed.
    deferStarMusic() {
        this.pendingStarMusic = true
    }

    dismiss() {
        this.activeVariant = null

        if (this.pendingStarMusic) {
            this.pendingStarMusic = false
            playMusicInterruption('musicStarCollect')
        }
    }

    reset() {
        this.activeVariant = null
        this.shown.clear()
        this.pendingStarMusic = false
    }
}
